<template>
    <div >
      <div class="single-wrapper-upper"  v-if="!add_collborator_form_status && !add_client_form_status">
          <div class="template-add-option">
              <div class="template-select-type">
               <div class="select-client-comp" id="clients-component-event">
                 <div class="form-group-select-client">
                   <div class="select-client-wrapper">
                     <input type="text" class="form-control" id='select-client-input'
                         v-model='search_client'
                         :placeholder='select_client ? clientName(select_client) : "Alege Client"'
                         @click="showDropdownList()"
                         autocomplete="off"
                     >
                     <i v-if="!select_client" class="fas fa-chevron-down" tabindex="1" @click="toogleDropdownList()"></i>
                     <i v-else class="fas fa-times-circle" @click="unselectClient()"></i>
                   </div>
                   <div id="clients-list-dropdown" style="display: none">
                     <div class="select-client-list">
                       <button :data-client-active="index" v-for="(client, index) in clients" :key="client.id" @keypress.enter="selectClient(index)" @click="activateClientDataActive(index)">{{ clientName(client) }}</button>
                     </div>
                   </div>
                 </div>
               </div>
               <b-form-checkbox
                      class="switch-button"
                      v-model="checked"
                      v-if="select_client"
                      name="check-button"
                      @change="select_client_form_status = !select_client_form_status"
                      switch
                      v-b-tooltip.hover :title="checked ? 'Afiseaza detalii' : 'Ascunde detalii'">
               </b-form-checkbox>
                <div class="button-group">
                  <button type="button" v-on:click="showFormCreateClient()"  @shortkey="showFormCreateClient()">
                      <i class="fas fa-user-plus"></i>
                      <span> {{$t('txt.adaugaClient')}} </span>
                  </button>
                </div>
              </div>
              <div class="template-select-type">
                <v-select v-model="selected_partner"
                          :placeholder="$t('placeholder.alegeColaboratorul')"
                          :options="partners"
                          :get-option-label="partnerName">
                </v-select>
                <div class="button-group">
                  <button type="button" v-on:click="showFormCreateCollaborator()" @shortkey="showFormCreateCollaborator()">
                      <i class="fas fa-user-plus"></i>
                      <span> {{$t('txt.adaugaColaborator')}} </span>
                  </button>
                </div>
              </div>
          </div>
      </div>
      <div class="offer-client-form order-client-container" :class="{ocf_active : select_client_form_status}" v-if="select_client">
          <h4> {{$t('txt.detaliiClient')}} </h4>
          <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <div v-for="input_field in client_fields.column_1"
                       :key="input_field.id">
                      <div class="form-group"
                           v-if="(input_field.personType === 0 || (select_client && input_field.personType == select_client.type && input_field.inputName !== ''))"
                       >
                        <div>
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   v-model="select_client[input_field.inputName]"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i :class="input_field.icon"></i>
                            </span>
                            <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                  </div>
                  <div class="selections-option" @click="selected_label = 3">
                      <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.alegeColaboratorul')}} </label>
                      <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                          <i class="fas fa-user-tie"></i>
                      </div>
                      <v-select v-model="selected_partner_edit"
                                :options="partners"
                                :get-option-label="partnerName">
                      </v-select>
                  </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <div class="form-group" v-for="input_field in client_fields.column_2" :key="input_field.id">
                      <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                          <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.judet')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="select_county"
                                    :options="counties"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    label="name"
                                    @change="getCitiesByCounty()">
                          </v-select>
                      </div>
                      <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                          <label :class="{select_label_class:selected_label === 2}"> {{$t('placeholder.oras')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 2}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="select_city"
                                    :options="cities"
                                    label="name"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName">
                          </v-select>
                      </div>
                      <div v-else>
                          <input type="text"
                                 class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :name="input_field.inputName"
                                 :data-vv-as="input_field.labelName"
                                 :id="input_field.inputName"
                                 v-model="input_field.inputValue">
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                          <i :class="input_field.icon"></i>
                      </span>
                      </div>
                      <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                  </div>
              </div>
          </div>
      </div>
      <form class="offer-client-form order-add-client" id="form-add-client" v-if="add_client_form_status" :class="{ocf_active : add_client_form_status}">
          <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <h4> {{$t('txt.detaliiFacturare')}} </h4>
                  <div class="type-person order-tp-container">
                      <div class="order-tp-wrapper">
                          <label class="container_check">
                              <input type="radio" value="1" name="type" v-model="personType" checked>
                              <span class="checkmark"></span>
                              {{$t('txt.persFizica')}}
                          </label>
                          <label class="container_check">
                              <input type="radio" value="2" name="type" v-model="personType">
                              <span class="checkmark"></span>
                              {{$t('txt.persJuridica')}}
                          </label>
                      </div>
                  </div>
                  <div class="form-group"
                       v-for="input_field in add_client_fields.column_1"
                       :key="input_field.id">
                       <div class="inputfield-wrapper" v-if="parseInt(personType) === parseInt(input_field.personType) || !input_field.personType">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i :class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                  </div>
                  <div class="form-group" v-for="input_field in add_client_fields.column_2" :key="input_field.id">
                      <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                          <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.judet')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="counties"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    :id="input_field.inputName"
                                    label="name"
                                    @input="getCitiesByCountyAddClient()">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                          <label :class="{select_label_class:selected_label === 2}"> {{$t('placeholder.oras')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 2}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="cities_add_client"
                                    label="name"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    :id="input_field.inputName">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div v-else>
                          <input type="text"
                                 class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :name="input_field.inputName"
                                 :data-vv-as="input_field.labelName"
                                 :id="input_field.inputName"
                                 v-model="input_field.inputValue">
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                      <i :class="input_field.icon"></i>
                  </span>
                      </div>
                      <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                  </div>
                  <div class="form-group">
                    <div class="selections-option" @click="selected_label = 3">
                        <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.alegeColaboratorul')}} </label>
                        <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                            <i class="fas fa-user-tie"></i>
                        </div>
                        <v-select v-model="selected_partner_add"
                                  :options="partners"
                                  :get-option-label="partnerName">
                        </v-select>
                    </div>
                  </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <h4 class="form-heading"> {{$t('txt.detaliiLivrare')}} </h4>
                  <input type="hidden" value='1' name="locatie_livrare">
                  <div class="form-group" v-for="input_field in add_client_fields.location" :key="input_field.id" :class="{ocf_active : select_location_form_status}">
                      <div class="selections-option" v-if="input_field.inputName === 'location_county'" @click="selected_label = 3">
                          <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.judet')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                              <i :class="input_field.icon"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="counties"
                                    label="name"
                                    :id="input_field.inputName"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    @change="getCitiesByCountyLocationAddClient()">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div class="selections-option" v-else-if="input_field.inputName === 'location_city'" @click="selected_label = 4">
                          <label :class="{select_label_class:selected_label === 4}"> {{$t('placeholder.oras')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 4}">
                              <i :class="input_field.icon"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :name="input_field.inputName"
                                    :options="cities_location_add_client"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    :id="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    label="name">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div v-else>
                          <input type="text"
                                 class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :name="input_field.inputName"
                                 :data-vv-as="input_field.labelName"
                                 v-model="input_field.inputValue"
                                 :id="input_field.inputName"
                          >
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                          <i v-bind:class="input_field.icon"></i>
                      </span>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                  </div>
                  <div class="offer-return-button">
                      <button type="button" @click="add_client_form_status = !add_client_form_status" v-shortkey="['ctrl', 'b']" @shortkey="add_client_form_status = !add_client_form_status">
                          <i class="fas fa-long-arrow-alt-left"></i>
                          {{$t('txt.inapoi')}}
                      </button>
                      <button type="button" @click="addClient()">
                          <i class="fas fa-check"></i>
                          {{$t('placeholder.salveaza')}}
                      </button>
                  </div>
              </div>
          </div>
      </form>
      <form class="offer-client-form order-add-client" id="form-add-collaborator" v-if="add_collborator_form_status" :class="{ocf_active : add_collborator_form_status}">
          <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <h4> {{$t('txt.detaliiFacturare')}} </h4>
                  <div class="type-person order-tp-container">
                      <div class="order-tp-wrapper">
                          <label class="container_check">
                              <input type="radio" value="1" name="type" v-model="personType" checked>
                              <span class="checkmark"></span>
                              {{$t('txt.persFizica')}}
                          </label>
                          <label class="container_check">
                              <input type="radio" value="2" name="type" v-model="personType">
                              <span class="checkmark"></span>
                              {{$t('txt.persJuridica')}}
                          </label>
                      </div>
                  </div>
                  <div class="form-group"
                       v-for="input_field in add_collaborator_fields.column_1"
                       :key="input_field.id">
                       <div class="inputfield-wrapper" v-if="parseInt(personType) === parseInt(input_field.personType) || !input_field.personType">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i :class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                  </div>
                  <div class="form-group" v-for="input_field in add_collaborator_fields.column_2" :key="input_field.id">
                      <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                          <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.judet')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="counties"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    :id="input_field.inputName"
                                    label="name"
                                    @input="getCitiesByCountyAddCollaborator()">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                          <label :class="{select_label_class:selected_label === 2}"> {{$t('placeholder.oras')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 2}">
                              <i class="fas fa-city"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="cities_add_collaborator"
                                    label="name"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    :id="input_field.inputName">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div v-else>
                          <input type="text"
                                 class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :name="input_field.inputName"
                                 :data-vv-as="input_field.labelName"
                                 :id="input_field.inputName"
                                 v-model="input_field.inputValue">
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                      <i :class="input_field.icon"></i>
                  </span>
                      </div>
                      <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                  </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <h4 class="form-heading"> {{$t('txt.detaliiLivrare')}} </h4>
                  <input type="hidden" value='1' name="locatie_livrare">
                  <div class="form-group" v-for="input_field in add_collaborator_fields.location" :key="input_field.id" :class="{ocf_active : select_location_form_status}">
                      <div class="selections-option" v-if="input_field.inputName === 'location_county'" @click="selected_label = 3">
                          <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.judet')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                              <i :class="input_field.icon"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :options="counties"
                                    label="name"
                                    :id="input_field.inputName"
                                    :name="input_field.inputName"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    @change="getCitiesByCountyLocationAddCollaborator()">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div class="selections-option" v-else-if="input_field.inputName === 'location_city'" @click="selected_label = 4">
                          <label :class="{select_label_class:selected_label === 4}"> {{$t('placeholder.oras')}} </label>
                          <div class="symbol-input" :class="{symbol_input_class:selected_label === 4}">
                              <i :class="input_field.icon"></i>
                          </div>
                          <v-select v-model="input_field.inputValue"
                                    :name="input_field.inputName"
                                    :options="cities_location_add_collaborator"
                                    :data-vv-as="input_field.labelName"
                                    :data-vv-name="input_field.inputName"
                                    :id="input_field.inputName"
                                    v-validate="input_field.validationRules"
                                    label="name">
                          </v-select>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                      <div v-else>
                          <input type="text"
                                 class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :name="input_field.inputName"
                                 :data-vv-as="input_field.labelName"
                                 v-model="input_field.inputValue"
                                 :id="input_field.inputName"
                          >
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                          <i v-bind:class="input_field.icon"></i>
                      </span>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                      </div>
                  </div>
                  <div class="offer-return-button">
                      <button type="button" @click="add_collborator_form_status  = !add_collborator_form_status"  @shortkey="add_collborator_form_status = !add_collborator_form_status">
                          <i class="fas fa-long-arrow-alt-left"></i>
                          {{$t('txt.inapoi')}}
                      </button>
                      <button type="button" @click="addCollaborator()">
                          <i class="fas fa-check"></i>
                          {{$t('placeholder.salveaza')}}
                      </button>
                  </div>
              </div>
          </div>
      </form>
    </div>
</template>

<script>
import ClientsService from '../api-services/clients.service'

import PartnersService from '../api-services/partners.service.js'
import CountiesService from '../api-services/counties.service.js'

import localforage from 'localforage'
import { EventBus } from '../main.js'
import Anaf from '../api-services/anaf.service.js';

export default {
  name: 'Clients',
  props: [
    'select_client_clone'
    // 'warehouses'
  ],
  data () {
    return {
      clients: [],
      search_client: null,
      lastDataClientActive: null,
      select_client: null,
      selectedFromList: true,
      add_collborator_form_status: false,
      add_client_form_status: false,
      partners: [],
      selected_partner: null,
      selected_partner_edit: null,
      selected_partner_add: null,
      collab_select_location: null,
      select_location_form_status: false,
      cities_location_add_client: [],
      cities_location_add_collaborator: [],
      cities_add_collaborator: [],
      selected_label: null,
      counties: [],
      cities: [],
      select_county: null,
      select_city: null,
      collaborator_form_status: false,
      cities_add_client: [],
      select_client_form_status: false,
      checked: true,
      personType: 1,
      source: null,
      dataParentClient: null,
      cui: ''
    }
  },
  watch: {
    search_client: window._.debounce(async function (val) {
      let response = await ClientsService.getFromLocalStorage({ q: val, per_page: 500 })
      this.clients = response
      this.lastDataClientActive = null
    }, 20),
    selected_partner: function () {
      this.$parent.select_partner = this.selected_partner
    },
    selected_partner_edit: function () {
      this.select_client.partner = this.selected_partner_edit
      this.$parent.select_client = this.select_client
    },
    cui: {
        handler: async function(value, oldValue) { 
            console.log("new Value", value);
            if (value) {
                try {
                  const response = await Anaf.getCompanyDetails(value);
                  if (response.data.hasOwnProperty("found")) {
                    document.getElementById('nr_reg').value = response.data.found[0].nrRegCom;
                    document.getElementById('phone').value = response.data.found[0].telefon;
                    document.getElementById('company_name').value = response.data.found[0].denumire;
                    document.getElementById('address').value = response.data.found[0].adresa;

                    this.add_client_fields.column_1.forEach((column) => {
                        if (column.inputName === 'nr_reg') {
                            column.inputValue = response.data.found[0].nrRegCom;
                        }
                        
                        if (column.inputName === 'phone') {
                            column.inputValue = response.data.found[0].telefon;
                        }
                        
                        if (column.inputName === 'company_name') {
                            column.inputValue = response.data.found[0].denumire;
                        }
                    });
                    
                    this.add_client_fields.column_2.forEach((column) => {
                        if (column.inputName === 'address') {
                            column.inputValue = response.data.found[0].adresa;
                        }
                    });
                    
                  }
                } catch (e) {
                    console.log(e);
                }
             }   
        },
         deep: true
    }
  },
  computed: {
    client_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.select_client) ? this.select_client.first_name : '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.select_client) ? this.select_client.last_name : '',
            icon: 'fas fa-signature',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.select_client) ? this.select_client.company_name : '',
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.select_client) ? this.select_client.phone : '',
            icon: 'fas fa-phone',
            validationRules: 'numeric',
            personType: 0
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: '',
            icon: 'fas fa-scroll',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: (this.select_client) ? this.select_client.cnp : '',
            icon: 'far fa-id-card',
            validationRules: 'numeric|max:13|max:13',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: (this.select_client) ? this.select_client.ci : '',
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: (this.select_client) ? this.select_client.ci_serie : '',
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.select_client) ? this.select_client.nr_reg : '',
            icon: 'fas fa-cash-register',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.select_client) ? this.select_client.bank : '',
            icon: 'fas fa-piggy-bank',
            validationRules: '',
            personType: 0
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.select_client) ? this.select_client.email : '',
            icon: 'fas fa-envelope',
            validationRules: 'email',
            personType: 0
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.select_client) ? this.select_client.county : null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.select_client) ? this.select_client.city : null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.select_client) ? this.select_client.address : '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    },
    add_collaborator_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: '',
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: '',
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: '',
            icon: 'fas fa-scroll',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.select_client) ? this.select_client.nr_reg : '',
            icon: 'fas fa-cash-register',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: '',
            icon: 'far fa-id-card',
            validationRules: 'numeric|max:13',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            icon: 'fas fa-envelope',
            validationRules: 'email'
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'location_county',
            labelName: this.$t('placeholder.judet'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'location_city',
            labelName: this.$t('placeholder.oras'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'location_address',
            labelName: this.$t('placeholder.adresa'),
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'location_name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    },
    add_client_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: '',
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: '',
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: '',
            icon: 'fas fa-scroll',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.select_client) ? this.select_client.nr_reg : '',
            icon: 'fas fa-cash-register',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: '',
            icon: 'far fa-id-card',
            validationRules: 'numeric|max:13|max:13',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            icon: 'fas fa-envelope',
            validationRules: 'email'
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'location_county',
            labelName: this.$t('placeholder.judet'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'location_city',
            labelName: this.$t('placeholder.oras'),
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'location_address',
            labelName: this.$t('placeholder.adresa'),
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'location_name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    }
  },
  methods: {
    completeLegalPersonData() {
        setInterval(() => {
            let cuiValue = document.getElementById('cui');
            if (cuiValue && cuiValue.value) {
                this.cui = cuiValue.value;
            }
        }, 1000);
    },
    showFormCreateClient () {
      this.$validator.reset()
      this.$validator.errors.clear()
      this.add_collborator_form_status = false
      this.select_client_form_status = false
      this.add_client_form_status = true
    },
    showFormCreateCollaborator () {
      this.$validator.reset()
      this.$validator.errors.clear()
      this.add_client_form_status = false
      this.select_client_form_status = false
      this.add_collborator_form_status = true
    },
    getPartnersFromLocalForage () {
      localforage.getItem('partners').then((response) => {
        this.partners = response.sort((a, b) => {
          let textA = ''
          let textB = ''
          if (a.company_name === null) {
            textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
          } else {
            textA = a.company_name.toUpperCase().trim()
          }
          if (b.company_name === null) {
            textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
          } else {
            textB = b.company_name.toUpperCase().trim()
          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      })
    },
    getPartners () {
      PartnersService.getAll({ per_page: -1 })
        .then((response) => {
          if (response.data.data.length) {
            this.partners = response.data.data
            this.editPreselectedClient(this.dataParentClient)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getClientsFromLocalForage (params) {
      await ClientsService.getFromLocalStorage(params)
        .then((response) => {
          this.clients = response
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
          if (this.select_client && this.select_client.county) {
            this.select_county = this.counties.find(county => county.id === this.select_client.county.id)
            this.getCitiesByCounty()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCountyLocationAddCollaborator () {
      let county = this.add_collaborator_fields.location.find(row => row.inputName === 'location_county')
      if (!county.inputValue) return
      let countyId = county.inputValue.id
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities_location_add_collaborator = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getCitiesByCountyAddCollaborator () {
      let county = this.add_collaborator_fields.column_2.find(row => row.inputName === 'county')
      let countyId = county.inputValue.id
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities_add_collaborator = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getCitiesByCountyAddClient () {
      let county = this.add_client_fields.column_2.find(row => row.inputName === 'county')
      let countyId = county.inputValue.id
      this.cities_add_client = []
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities_add_client = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    changeClient () {
      if (this.select_client) {
        this.add_client_form_status = false
        this.select_client_form_status = false
        this.select_county = this.select_client.county
        this.client_locations = this.select_client.locations
        if (this.select_client.due_date) {
          let now = new Date()
          now.setDate(now.getDate() + parseInt(this.select_client.due_date))
          let dueDateOldFormat = now.toISOString().slice(0, 10).split('-')
          this.due_date = dueDateOldFormat[2] + '-' + dueDateOldFormat[1] + '-' + dueDateOldFormat[0]
        }
        if (this.select_client.partner) {
          this.selected_partner = this.partners.find(partners => parseInt(partners.id) === parseInt(this.select_client.partner.id))
          this.selected_partner_edit = this.partners.find(partners => parseInt(partners.id) === parseInt(this.select_client.partner.id))
        }
        this.checked = true
      } else {
        this.checked = false
      }
    },
    async addClient () {
      let validatorResp = true
      await this.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$validator.errors && !result) {
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('form-add-client'))
      let county = this.add_client_fields.column_2.find(county => county.inputName === 'county')
      let city = this.add_client_fields.column_2.find(city => city.inputName === 'city')
      if (county && county.inputValue) {
        formData.append('county', county.inputValue.id)
      }
      if (city && city.inputValue) {
        formData.append('city', city.inputValue.id)
      }
      if (this.selected_partner_add) {
        formData.append('partner', this.selected_partner_add.id)
      }
      let locationCounty = this.add_client_fields.location.find(county => county.inputName === 'location_county')
      let locationCity = this.add_client_fields.location.find(city => city.inputName === 'location_city')
      if (locationCounty && locationCounty.inputValue) {
        formData.append('location_county', locationCounty.inputValue.id)
      }
      if (locationCity && locationCity.inputValue) {
        formData.append('location_city', locationCity.inputValue.id)
      }
      ClientsService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.clientAdaugat'),
              'animation-type': 'css'
            })
            document.getElementById('form-add-client').reset()
            this.selected_partner_add = null
            this.add_client_form_status = false
            if (response.data.data.partner) {
              this.partners.push(response.data.data.partner)
            }
            this.clients.push(response.data.data)
            this.select_client = this.clients.find(client => client.id === response.data.data.id)
            this.$parent.select_client = this.select_client
            this.changeClient()
            this.addClientToLocalForage(this.select_client)

            for (let key in this.add_client_fields) {
              for (let element in this.add_client_fields[key]) {
                this.add_client_fields[key][element]['inputValue'] = ''
              }
            }
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) return
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    async addCollaborator () {
      let validatorResp = true
      await this.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$validator.errors && !result) {
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      let formData = new FormData(document.getElementById('form-add-collaborator'))
      let county = this.add_collaborator_fields.column_2.find(county => county.inputName === 'county')
      let city = this.add_collaborator_fields.column_2.find(city => city.inputName === 'city')
      if (county && county.inputValue) {
        formData.append('county', county.inputValue.id)
      }
      if (city && city.inputValue) {
        formData.append('city', city.inputValue.id)
      }
      if (this.selected_partner) {
        formData.append('partner', this.selected_partner.id)
      }
      let locationCounty = this.add_collaborator_fields.location.find(county => county.inputName === 'location_county')
      let locationCity = this.add_collaborator_fields.location.find(city => city.inputName === 'location_city')
      if (locationCounty && locationCounty.inputValue) {
        formData.append('location_county', locationCounty.inputValue.id)
      }
      if (locationCity && locationCity.inputValue) {
        formData.append('location_city', locationCity.inputValue.id)
      }
      PartnersService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.partnerAdaugat'),
              'animation-type': 'css'
            })

            this.add_collborator_form_status = false
            this.partners.push(response.data.data)
            this.selected_partner = this.partners.find(partner => partner.id === response.data.data.id)

            this.$parent.select_partner = this.selected_partner
            for (let key in this.add_collaborator_fields) {
              for (let element in this.add_collaborator_fields[key]) {
                this.add_collaborator_fields[key][element]['inputValue'] = ''
              }
            }
            this.addPartnerToLocalForage(this.selected_partner)
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) return
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    getCitiesByCountyLocationAddClient () {
      let county = this.add_client_fields.location.find(row => row.inputName === 'location_county')
      let countyId = county.inputValue.id
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities_location_add_client = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getCitiesByCounty () {
      let countyId = this.select_county.id
      this.cities = []
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
            if (this.select_client.city) {
              this.select_city = this.cities.find(city => city.id === this.select_client.city.id)
            }
          })
          .catch((error) => {
            console.log(error)
          })
        return false
      }
    },
    activateClientDataActive (index) {
      this.lastDataClientActive = index
      window.$('[data-client-active=' + this.lastDataClientActive + ']').focus()
      this.selectClient(index)
    },
    toogleDropdownList () {
      if (window.$('#clients-list-dropdown').is(':hidden')) {
        window.$('#clients-list-dropdown').show()
      } else {
        window.$('#clients-list-dropdown').hide()
      }
    },
    showDropdownList () {
      this.lastDataClientActive = null
      window.$('#clients-list-dropdown').show()
    },
    selectClient (index) {
      this.$validator.reset()
      this.$validator.errors.clear()
      this.selectedFromList = true
      this.select_client = this.clients[index]
      this.$parent.select_client = this.select_client

      let priceCat = this.$parent.priceCategoryes.find(p => parseInt(p.value) === parseInt(this.select_client.price_category))
      if (priceCat) {
        this.$parent.globalPriceRange = {
          key: priceCat.value,
          name: priceCat.name
        }
      } else {
        this.$parent.globalPriceRange = {
          key: 5,
          name: 'pp_amanunt'
        }
      }

      this.changeClient()
      this.search_client = ''
      window.$('#clients-list-dropdown').hide()
    },
    unselectClient (index) {
      this.select_client = null
      this.search_client = ''
      this.selected_partner = null
      this.$parent.select_client = null
      this.$parent.select_client_clone = null
      this.lastDataClientActive = null
    },
    editPreselectedClient (data) {
      if (!data) return
      this.dataParentClient = data
      let vm = this
      vm.select_client = vm.clients.find(x => x.id === data.clientId)
      if (vm.select_client) {
        vm.selectClient(vm.clients.lastIndexOf(vm.select_client))
        vm.selected_partner = vm.partners.find(x => x.id === data.partnerId)
        let ff = vm.partners.find(partners => parseInt(partners.id) === parseInt(vm.select_client.partner.id))
        if (ff) {
          vm.selected_partner_edit = ff
        }
        vm.$parent.select_partner = vm.selected_partner
      } else {
        ClientsService.getClientById(data.clientId)
          .then((response) => {
            vm.clients.push(response)
            vm.selectClient(vm.clients.lastIndexOf(response))
            vm.selected_partner = vm.partners.find(x => x.id === data.partnerId)
            let ff = vm.partners.find(partners => parseInt(partners.id) === parseInt(response.partner ? response.partner.id : -1))
            if (ff) {
              vm.selected_partner_edit = ff
            }
            vm.$parent.select_partner = vm.selected_partner
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  },
  mounted () {
    let vm = this
    document.getElementById('clients-component-event').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.closest('.select-client-comp') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataClientActive = vm.lastDataClientActive == null ? 0 : vm.lastDataClientActive + 1
          if (vm.lastDataClientActive === vm.clients.length) {
            vm.lastDataClientActive--
          }
        } else {
          vm.lastDataClientActive = vm.lastDataClientActive < 1 ? 0 : vm.lastDataClientActive - 1
        }
        window.$('[data-client-active=' + vm.lastDataClientActive + ']').focus()
      }
    })
  },
  async created () {
    await ClientsService.reinitiateResource()
    await this.getClientsFromLocalForage({ per_page: 500 })
    await this.getPartnersFromLocalForage()
    await this.getPartners()
    this.getCounties()
    this.completeLegalPersonData();
  }
}
</script>
